import { createSelector } from '@ngrx/store';
import { selectOfflineFeature } from './pace-offline-feature.selector';

export const selectOfflineCacheInfo = createSelector(selectOfflineFeature, (state) => state.cacheInfo);

export const selectRehydrationCompletedState = createSelector(selectOfflineCacheInfo, (state) => state.rehydrated);
